import { FetchBaseQueryMeta } from '@reduxjs/toolkit/query';
import {
  BusinessInfoResponse,
  BusinessInsightsRequest,
  VisibilityScoreResponse,
  VisibilityScoreRequest,
  GenerateReportResponse,
  GenerateReportRequest,
} from './apiTypes';
import { emptyApiSlice } from './emptyApiSlice';

export const reportApiSlice = emptyApiSlice.injectEndpoints({
  endpoints: builder => ({
    getBusinessInsights: builder.query<
      BusinessInfoResponse,
      BusinessInsightsRequest
    >({
      query: requestData => ({
        url:
          '/v1/business-insights' +
          (requestData.reportId
            ? `?report-id=${encodeURIComponent(requestData.reportId)}`
            : ''),
        method: 'POST',
        body: requestData,
      }),
      providesTags: ['BusinessInsights'],
      transformResponse: (
        raw: BusinessInfoResponse,
        meta: FetchBaseQueryMeta
      ) => ({
        ...raw,
        statusCode: meta?.response?.status,
      }),
    }),
    getVisibilityScore: builder.query<
      VisibilityScoreResponse,
      VisibilityScoreRequest
    >({
      query: requestData => ({
        url:
          '/v1/visibility/score' +
          (requestData.reportId
            ? `?report-id=${encodeURIComponent(requestData.reportId)}`
            : ''),
        method: 'POST',
        body: requestData,
      }),
      providesTags: ['VisibilityScore'],
      transformResponse: (
        raw: VisibilityScoreResponse,
        meta: FetchBaseQueryMeta
      ) => ({
        ...raw,
        statusCode: meta?.response?.status,
      }),
    }),
    generateFullReport: builder.mutation<
      GenerateReportResponse,
      GenerateReportRequest
    >({
      query: ({ domain, lang }) => ({
        url: '/reports/recreate-full',
        method: 'POST',
        body: { domain, lang },
        responseHandler: 'json',
        validateStatus: (response: Response) => response.status === 202,
      }),
      transformResponse: (raw: GenerateReportResponse) => raw,
      // Invalidate user info so polling loop picks up BUSY status changes
      invalidatesTags: [
        'UserInfo',
        'BusinessInfo',
        'BusinessInsights',
        'Metrics',
        'VisibilityRules',
        'VisibilityScore',
        'TargetAudience',
        'GeographicFocus',
        'BusinessAddress',
        'BusinessName',
      ],
    }),
  }),
});

export const {
  useGetBusinessInsightsQuery,
  useGetVisibilityScoreQuery,
  useGenerateFullReportMutation,
} = reportApiSlice;
